

/// <reference path="SalesAnnotation.ts" />

// Generated class SalesMenuAnnotation_ManagedObject

class SalesMenuAnnotation_ManagedObject extends SalesAnnotation
{
}
